module.exports = __webpack_public_path__ + "img/ipad-brush-diagram.598ccbd.jpg";